export enum ServiceCategories {
    Arrival = 1,
    Departure,
}

export const ServiceCategoriesMap = {
    [ServiceCategories.Arrival]: 'Arrival',
    [ServiceCategories.Departure]: 'Departure',
};
